/* Anike Editorial · theme.js */
(function () {
  // Countdown: <span data-countdown="2026-09-25T23:59:00+02:00" data-days="d" data-hours="h" data-min="m">
  document.querySelectorAll('[data-countdown]').forEach(function (el) {
    var target = new Date(el.getAttribute('data-countdown')).getTime();
    if (isNaN(target)) return;
    var dl = el.getAttribute('data-days') || 'd', hl = el.getAttribute('data-hours') || 'h', ml = el.getAttribute('data-min') || 'm';
    function tick() {
      var diff = target - Date.now();
      if (diff <= 0) { el.textContent = el.getAttribute('data-closed') || 'closed'; return; }
      var d = Math.floor(diff / 864e5), h = Math.floor(diff % 864e5 / 36e5), m = Math.floor(diff % 36e5 / 6e4);
      el.textContent = (d > 0 ? d + dl + ' ' : '') + h + hl + ' ' + m + ml;
    }
    tick(); setInterval(tick, 30000);
  });

  // Mobile menu toggle
  var toggle = document.querySelector('[data-menu-toggle]');
  var menu = document.querySelector('[data-mobile-menu]');
  if (toggle && menu) {
    toggle.addEventListener('click', function () {
      var open = menu.hasAttribute('hidden');
      if (open) { menu.removeAttribute('hidden'); } else { menu.setAttribute('hidden', ''); }
      toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
      document.body.classList.toggle('menu-open', open);
    });
  }

  // Quantity buttons
  document.querySelectorAll('[data-qty]').forEach(function (wrap) {
    var input = wrap.querySelector('input');
    wrap.querySelectorAll('button').forEach(function (b) {
      b.addEventListener('click', function () {
        var v = parseInt(input.value || '1', 10);
        v = b.getAttribute('data-dir') === 'up' ? v + 1 : Math.max(1, v - 1);
        input.value = v;
        input.dispatchEvent(new Event('change', { bubbles: true }));
      });
    });
  });

  // Variant selection: update hidden id, price, availability
  document.querySelectorAll('[data-product-form]').forEach(function (form) {
    var variants = [];
    try { variants = JSON.parse(form.querySelector('[data-variants]').textContent); } catch (e) { return; }
    var idInput = form.querySelector('input[name="id"]');
    var priceEl = form.querySelector('[data-price]');
    var btn = form.querySelector('[data-add]');
    var stockEl = form.querySelector('[data-stock]');
    function money(cents) {
      var fmt = form.getAttribute('data-money') || '{{amount}} €';
      var amount = (cents / 100).toFixed(2).replace('.', fmt.indexOf('{{amount_with_comma_separator}}') > -1 ? ',' : '.');
      return fmt.replace(/\{\{\s*amount(_with_comma_separator)?\s*\}\}/, amount);
    }
    function update() {
      var chosen = [];
      form.querySelectorAll('[data-option]').forEach(function (group) {
        var checked = group.querySelector('input:checked');
        chosen.push(checked ? checked.value : null);
      });
      var v = variants.find(function (x) {
        return chosen.every(function (c, i) { return c === null || x.options[i] === c; });
      });
      if (!v) return;
      idInput.value = v.id;
      if (priceEl) priceEl.textContent = money(v.price);
      if (btn) {
        btn.disabled = !v.available;
        btn.textContent = v.available ? btn.getAttribute('data-label-add') : btn.getAttribute('data-label-sold');
      }
      if (stockEl && v.inventory_management === 'shopify' && v.inventory_quantity > 0 && v.inventory_quantity <= 50) {
        stockEl.hidden = false;
        stockEl.querySelector('strong').textContent = v.inventory_quantity;
      } else if (stockEl) { stockEl.hidden = true; }
    }
    form.querySelectorAll('[data-option] input').forEach(function (i) { i.addEventListener('change', update); });
    update();
  });

  // Cart count after add (AJAX add to cart)
  document.querySelectorAll('[data-product-form]').forEach(function (form) {
    form.addEventListener('submit', function (e) {
      if (!window.fetch) return;
      e.preventDefault();
      var btn = form.querySelector('[data-add]');
      var label = btn.textContent;
      btn.textContent = btn.getAttribute('data-label-adding') || '…';
      fetch(form.getAttribute('action') || '/cart/add.js', { method: 'POST', headers: { 'Accept': 'application/json' }, body: new FormData(form) })
        .then(function (r) { return r.json(); })
        .then(function () {
          return fetch('/cart.js').then(function (r) { return r.json(); });
        })
        .then(function (cart) {
          document.querySelectorAll('[data-cart-count]').forEach(function (c) { c.textContent = cart.item_count; });
          btn.textContent = btn.getAttribute('data-label-added') || label;
          setTimeout(function () { btn.textContent = label; }, 2000);
        })
        .catch(function () { form.submit(); });
    });
  });

  // Cookie settings: opens Shopify's consent banner again (Customer Privacy API); falls back to the cookie page.
  document.querySelectorAll('[data-cookie-settings]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var opened = false;
      try {
        if (window.Shopify && window.Shopify.customerPrivacy && typeof window.Shopify.customerPrivacy.showPreferences === 'function') { window.Shopify.customerPrivacy.showPreferences(); opened = true; }
        else if (window.Shopify && typeof window.Shopify.loadFeatures === 'function') {
          window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], function (err) {
            if (!err && window.Shopify.customerPrivacy && window.Shopify.customerPrivacy.showPreferences) { window.Shopify.customerPrivacy.showPreferences(); }
          });
          opened = true;
        }
      } catch (e) {}
      if (!opened) { document.dispatchEvent(new CustomEvent('anike:cookie-settings')); }
    });
  });
})();
